import React from 'react';
import useFetch from '../../../../components/hooks/useFetch.js';
import { abreAlertaDialog } from '../../../../components/modal/AlertaDialog.js';
import {
  CONTRATO_EXCLUIR
} from '../../../../services/permissoesRecebidas.js';

function FormExcluirContrato({
  acaoCancelar,
  acaoFechar,
  contratoSelecionado,
  idCorreios,
  idCorreiosPJ,
}) {
  const { request } = useFetch();
  const cancelar = (ev) => {
    ev.preventDefault();
    acaoCancelar();
  };

  const excluir = async () => {
    const { response } = await request(
      CONTRATO_EXCLUIR(idCorreios, 
        idCorreiosPJ, 
        contratoSelecionado.nuContrato, 
        contratoSelecionado.contrato.nuSe 
        ),
    );

    if (response.ok) {
      abreAlertaDialog('Contrato excluido com sucesso!');
      acaoFechar();
    }
  };

  return (
    <>
      <div className="dialog-container">
        <div className="dialog-header">
          <h2>Excluir "{contratoSelecionado?.nuContrato}"</h2>
        </div>
        <div className="dialog-main" id="dialog-main-email">
          Tem certeza de que deseja excluir esse Contrato?
        </div>
        <div className="dialog-footer">
          <button className="btn-txt btn-fecha-dialog" onClick={cancelar}>
            Cancelar
          </button>
          <button className="btn-pre" id="btn-excluir" onClick={excluir}>
            Excluir
          </button>
        </div>
      </div>
    </>
  );
}
export default FormExcluirContrato;
